import { Binding } from '@app/lib/binding'
import { BackButton } from '@app/lib/buttons'
import {
	DataGrid,
	DataGridColumn,
	DataGridDateTimeColumn,
	DataGridEnumColumn,
	DataGridLoader,
	DataGridPagination,
	DataGridQueryFilter,
	DataGridTable,
	DataGridTextColumn,
	DataGridToolbar,
} from '@app/lib/datagrid'
import { Slots } from '@app/lib/layout'
import { Field } from '@contember/react-binding'

export default () => {
	return (
		<>
			<Binding>
				<div className="flex flex-col gap-12">
					<Slots.Title>Form submission list</Slots.Title>
					<Slots.Back>
						<BackButton />
					</Slots.Back>
					<>
						<DataGrid entities="FormSubmission">
							<DataGridToolbar>
								<DataGridQueryFilter />
							</DataGridToolbar>
							<DataGridLoader>
								<DataGridTable>
									<DataGridEnumColumn header="Source page" field="sourcePage" options={{ contact: 'Contact', career: 'Career' }} />
									<DataGridTextColumn header="Email" field="email" />
									<DataGridTextColumn header="Message" field="message" />
									<DataGridDateTimeColumn field="createdAt" header="Submitted at" />
									<DataGridTextColumn header="Campaign" field="campaign" />
									<DataGridTextColumn header="Medium" field="medium" />
									<DataGridTextColumn header="Source" field="source" />
									<DataGridColumn header="Metadata">
										<Field field="metadata" format={metadata => JSON.stringify(metadata)} />
									</DataGridColumn>
								</DataGridTable>
							</DataGridLoader>
							<DataGridPagination />
						</DataGrid>
					</>
				</div>
			</Binding>
		</>
	)
}
